import { useEffect } from 'react'
import Layout from '../components/Layout'
import BottomButton from '../components/BottomButton'
import { logPageView } from '../lib/analytics'
import { useRouter } from 'next/router'
import TouContent from '../components/TouContent'

export default function TOU() {
  const router = useRouter()
  const query = router.query.back || '/'
  let backURL = query === 'join' ? '/join' : ''
  if (query === 'dashboard') {
    backURL = '/dashboard#profile'
  }
  if (query === 'desktop') {
    backURL = '/desktop'
  }
  if (query === 'vote-early') {
    backURL = '/'
  }

  useEffect(() => {
    logPageView('tou')
  }, [])

  return (
    <div id="tou">
      <Layout title="Terms Of Use" url="tou">
        <TouContent />
        {backURL && (
          <BottomButton gtm="gtm-terms-of-use" text="Go Back" href={backURL}>
            Go Back
          </BottomButton>
        )}
      </Layout>
    </div>
  )
}
